<template>
  <List :mapState="'adminSchools'" :allDispatch="'adminSchoolsAll'"></List>
</template>
<script>
import List from '@/components/modules/base/list.vue'
export default {
  name: 'Lists',
  components: {
    List
  }
}
</script>



// WEBPACK FOOTER //
// src/components/modules/admin/schools/list.vue